// @styles
import './styles.scss'
// import { Button } from 'antd';
// import { formatPrice, getValueField } from 'utils/utils';
// @context
import Context from 'context/appContext';

// @vendors
import { useState, useEffect, useContext } from 'react';
import cx from 'classnames'

// @utils
import { getValueField, formatPrice, getDescriptionSelect, getBody } from '../../../utils/utils';

// @Components
import CollapseComponent from '../collapse';

import { Button, Modal } from 'antd';
import moment from 'moment';

export default function SidebarResume({ info, cost, service }) {
    const { formStatus: { steps, currentStep }, setFormStatus, homePageData, setHomePageData, showHomePage,
        dataForm: { data, formResponses }, priceToShow, fileRequest, setDisabledButtonContinue, setReturnButton, currency, tokenInfo, customRequest, setPolicyNumber, setPriceToShow
    } = useContext(Context);
    //

    // const {  } = useContext(Context);
    const plan = getValueField('planes', formResponses)[0];
    const [priceValue, setPriceValue] = useState(plan ? plan.valor : '0000');
    const [download, setDownload] = useState(false);
    const [openSidebar, setOpenSidebar] = useState(false);
    const [openDetail, setOpenDetail] = useState(false);

    useEffect(() => {
        setPriceValue(priceToShow);
    }, [priceToShow]);

    const tipoInmueble = getValueField('tipoInmueble', formResponses);
    const tipoInmuebleLabel = formResponses.find(x => x.key === 'tipoInmueble')?.name;

    const modal = (message, title) => {
        Modal.info({
            icon: '',
            title: title ? title : 'Error',
            className: 'modal-confirm',
            closable: true,
            okButtonProps: {
                className: 'ant-btn-solid c-2 ant-btn-size-xs'
            },
            okText: 'Aceptar',
            content: <p>{message}</p>,
            onOk() { }
        });
    }

    const objType = {
        'application/pdf': '.pdf'
    }

    const setModel = (policy) => {
        if (policy && Object.keys(policy).length > 0) {
            data.modelConfig['configurationPolicy'] = {
                "officeId": policy.officeId,
                "productId": policy.productId,
                "status": "W",
                "policyNumber": policy.policyNumber,
                "folioFromPartner": 0,
                "rfc": "XXXXXXX"
            };
        }
    }

    const callService = async () => {
        if (data && data.modelConfig) {
            setDownload(true);
            setDisabledButtonContinue(true);
            setReturnButton(false);
            const modelConfig = data && data.modelConfig ? data.modelConfig : {};
            const indexQuotation = steps.findIndex(x => x.key_step === 'step_coberturas_adicionales');
            const dataStepQuotation = indexQuotation !== -1 && steps[indexQuotation] && steps[indexQuotation].questions[0].primary.opciones_servicio;
            const optionsAlea = JSON.parse(dataStepQuotation);
            const optionsImp = JSON.parse(service);
            const bodyAlea = getBody({}, modelConfig, formResponses, [], tokenInfo);
            await customRequest(optionsAlea.url, optionsAlea.headers, optionsAlea.method, bodyAlea).then(async res => {
                const policy = res && res.data && res.data.policy;

                if (policy) {
                    const policyNumber = policy.policyNumber;
                    policyNumber && setPolicyNumber(policyNumber);
                    res.data.costs && res.data.costs.amount && setPriceToShow(res.data.costs.amount);

                    // Requote old
                    data['infoRequote'] = { res, infoRequest: optionsAlea };
                    setModel(policy);

                    const bodyPDF = {
                        oficina: policy.officeId,
                        ramo: policy.productId,
                        poliza: policy.policyNumber,
                        estado: policy.status,
                        suplemento: 0,
                        rfc: ''
                    };
                    const response = await fileRequest(optionsImp.url, optionsImp.headers, optionsImp.method, bodyPDF);
                    if (response && response.size > 0 && response.type) {
                        const type = objType[response.type];
                        const name = bodyPDF['estado'] === 'W' ? 'cotizacion' : 'emision';
                        const a = document.createElement('a');
                        a.href = window.URL.createObjectURL(response);
                        a.download = `${name}-${policy.policyNumber}${type}`
                        a.click();
                    } else {
                        modal('No pudimos descargar el archivo. Vuelve a intentarlo más tarde.', 'Ups...');
                    }
                } else {
                    modal(res && res.errors && res.errors.fields && res.errors.fields[0] || res && res.errors && res.errors.errors[0] && res.errors.errors[0].description);
                }
            }

            ).catch(error => {
                modal(error && error.errors && error.errors.fields && error.errors.fields[0] || 'No se ha podido realizar la descarga del documento.');
            })
        }
        setDownload(false);
        setDisabledButtonContinue(false);
        setReturnButton(true);
    }
    const setFormatDate = (fecha) => {
        const formatPosible = ["DD/MM/YYYY", "YYYY-MM-DD", "DD/MM/YYYY HH:mm"]
        return moment(fecha, formatPosible).format('DD/MM/YYYY');
    }

    //
    const setForm = {
        steps,
        currentQuestion: 0,
        currentStep: currentStep + 1,
        numberQuestionsStep: steps[currentStep + 1]?.questions.length
    }

    const onClick = () => {
        if (info && info.urlredirect && info.urlredirect.length > 10) {
            setHomePageData({ ...homePageData, links: null });
            // setShowHomePage(false);
            setFormStatus(setForm);
            document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return showHomePage || currentStep === 0 && info ? (
        <div className='sidebar-resume' >
            <div className='sidebar-resume__header'>
                <p>{info.sidebartitle}</p>
            </div>
            <div className='sidebar-resume__title'>
                Contrata desde
            </div>
            <div>
                <div className='sidebar-resume__price'>
                    {formatPrice(cost)}
                </div>
                <p className='sidebar-resume__description'>
                    {info.sidebardescription}
                </p>
                <ul className='sidebar-resume__list'>
                    {info.sidebaritems.length > 0 && info.sidebaritems.map((item) =>
                        <li>
                            <em className='fal fa-check-circle' />
                            <p>{item.text}</p>
                        </li>
                    )}
                </ul>
            </div>
            <div className='sidebar-resume__actions'>
                <Button
                    className='ant-btn-solid c-3 ant-btn-size-xs'
                    onClick={onClick}
                >
                    <strong>Continuar</strong>
                </Button>
            </div>
        </div>
    ) :

        (
            <div className={
                cx(
                    'sidebar-resume',
                    'sidebar-resume-completed',
                    {
                        'sidebar-resume-visible': openSidebar
                    }
                )
            }>
                {/* {download && (<Loading/>)} */}
                {/* {!priceValue && (<div className='sidebar-resume__load'>
                Estamos generando tu cotización...
            </div>)} */}

                {(<div className='sidebar-resume__header'>
                    <div className='sidebar-resume__price'>
                        <p>{priceValue >= 0 ? formatPrice((Math.round(priceValue))) : 0} <strong className='currency-type'>{currency ? 'MXN' : 'USD'}</strong></p>
                        <span className='sidebar-resume__price-help'>
                            EL COSTO ANUAL SERÁ
                        </span>
                    </div>
                    {service && (<Button
                        className="ant-btn-outline c-1 ant-btn-size-xxs download-button"
                        onClick={() => callService()}
                        disabled={download}
                    >
                        <em className="fal fa-download" />
                        {download ? 'Descargando...' : 'Descarga tu cotización'}
                    </Button>)}
                </div>)}

                <CollapseComponent />
                <div className={`sidebar-resume__detail ${openDetail ? 'open-detail' : ''}`}>
                    <div className='sidebar-resume__detail-btn'>
                    </div>
                    <div className='sidebar-resume__detail-title' onClick={() => setOpenDetail(!openDetail)}>
                        DETALLE COTIZACIÓN
                    </div>
                    <div className='sidebar-resume__detail-description'>
                        <ul>
                            <li>
                                <p>CÓDIGO POSTAL</p>
                                <p>{getValueField('codigoPostal', formResponses)}</p>
                            </li>
                            <li>
                                <p>TIPO DE INMUEBLE</p>
                                <p>{tipoInmuebleLabel && tipoInmuebleLabel.toUpperCase()}</p>
                            </li>
                            <li>
                                {tipoInmueble === '3' &&
                                    (<p>VIGENCIA</p>)}
                                {
                                    tipoInmueble === '3' && (<p>{`${setFormatDate(getValueField('inicioVigenciaSeguro', formResponses))} - ${setFormatDate(getValueField('finVigenciaSeguro', formResponses))}`}</p>)
                                }

                                {/* <p title={getDescriptionSelect(getValueField('giro', formResponses), giroField && giroField.valuesResponse)}>{getDescriptionSelect(getValueField('giro', formResponses), giroField && giroField.valuesResponse)}</p> */}
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    className='sidebar-resume__open'
                    onClick={() => setOpenSidebar(!openSidebar)}
                >
                    <em className='fal fa-chevron-down' /> {openSidebar ? 'Ver menos' : 'Ver más'}
                </div>
            </div>
        )

}